import { Checkbox, FormControlLabel, Stack, useTheme } from "@mui/material";
import * as React from "react";

export interface IHCheckbox {
    /** The checked state of the checkbox */
    checked: boolean;
    /** The disabled state of the checkbox */
    disabled?: boolean;
    /** The checkbox's label */
    label?: React.ReactNode;
    /** The checkbox's click callback */
    onClick?: (e: any) => void;
    /** Additional styles for checkbox */
    style?: React.CSSProperties & { disabledColor?: React.CSSProperties["color"] };
    /** The style for the checkbox and label's container */
    containerStyle?: React.CSSProperties;
    /** The rest of checkbox's props */
    checkboxProps?: any;
    /** The checkbox's name */
    name?: string;
    /** Additional input props */
    inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
    /** spacing between checkbox and label, default: 1 */
    spacing?: number;
    alignItems?: string;
}

export const HCheckbox = ({
    checked,
    disabled,
    label,
    onClick,
    style,
    containerStyle,
    checkboxProps,
    spacing = 1,
    alignItems,
    ...rest
}: IHCheckbox) => {
    const theme = useTheme();
    return (
        <Stack style={{ flexDirection: "row", justifyContent: "flex-start" }}>
            <Stack
                direction="row"
                justifyContent="flex-start"
                alignItems={alignItems || "flex-start"}
                onClick={(e: React.MouseEvent<HTMLDivElement>) => {
                    if (!disabled) {
                        e.preventDefault();
                        onClick && onClick(e);
                    }
                }}
                style={{ cursor: disabled ? "default" : "pointer", ...containerStyle }}
                spacing={spacing}
            >
                <FormControlLabel
                    {...rest}
                    label={undefined}
                    control={
                        <Checkbox
                            {...checkboxProps}
                            checked={checked}
                            disabled={disabled}
                            style={{
                                ...style,
                                color: disabled
                                    ? style?.disabledColor ?? theme.palette.extendedGrey3.main
                                    : style?.color ?? theme.palette.primaryBlack.main,
                            }}
                        />
                    }
                    slotProps={{ typography: { sx: { whiteSpace: "nowrap" } } }}
                    style={{ marginRight: "unset" }}
                />
                <Stack alignItems="flex-start">{label}</Stack>
            </Stack>
        </Stack>
    );
};

HCheckbox.displayName = "HCheckbox";
